import React from "react";
import LogoImage from '../../assets/images/vempix_logo.png';
import './Logo.css';

const Logo = ({ onClick }) => {
    return (
        <div className="Logo" onClick={onClick} style={{ cursor: 'pointer' }}>
            <img src={LogoImage} alt="Logo" />
        </div>
    );
}

export default Logo;
